<div id="news-events" class="my-3 py-5">
    <div class="container">
        <div class="row d-flex flex-wrap justify-content-center">

            <!-- CIRCULAR / NOTICES -->
            <div class="col-12 col-md-4 mb-3">
                <div class="card news shadow mx-auto ml-md-4 mb-2" data-scroll>
                    <div class="card-header home-title">
                        CIRCULAR / NOTICES
                    </div>
                    <ul class="list-group list-group-flush">
                        <marquee behavior="scroll" direction="up" onmouseover="this.stop();" onmouseout="this.start();">
                            <li class="list-group-item" *ngFor="let item of circular;" (click)="openItem(item)" [style.cursor]="item?.urlPath ? 'pointer' : 'default'">
                                <div class="row">
                                    <div class="col-5 col-lg-4">
                                        <div class="box d-flex justify-content-center align-items-center rounded-3">
                                            <p class="mb-0 py-4" style="font-size: 13px; text-align: center;">{{ item?.date }}</p>
                                        </div>
                                    </div>
                                    <div class="col-7 col-lg-8">
                                        <a *ngIf="item?.urlPath" [href]="item.urlPath" target="_blank" rel="noopener noreferrer" class="text-primary text-decoration-none fw-semibold">{{ item?.title }} <i class="fa-solid fa-arrow-up-right-from-square small ms-1"></i></a>
                                        <a *ngIf="!item?.urlPath" class="fw-semibold">{{ item?.title }}</a><br>
                                        <small *ngIf="item?.desc">{{ item.desc.length > 100 ? (item.desc | slice: 0:100) + '...' : item.desc }}</small>
                                    </div>
                                </div>
                            </li>
                        </marquee>
                    </ul>
                </div>
            </div>

            <!-- PRESS & MEDIA -->
            <div class="col-12 col-md-4 mb-3">
                <div class="card news shadow media mx-auto ml-md-4 mb-2" data-scroll>
                    <div class="card-header home-title">
                        PRESS &amp; MEDIA
                    </div>
                    <ul class="list-group list-group-flush">
                        <marquee behavior="scroll" direction="up" onmouseover="this.stop();" onmouseout="this.start();">
                            <li class="list-group-item" *ngFor="let item of press;" (click)="openItem(item)" [style.cursor]="item?.urlPath ? 'pointer' : 'default'">
                                <div class="row">
                                    <div class="col-5 col-lg-4">
                                        <div class="box d-flex justify-content-center align-items-center rounded-3">
                                            <p class="mb-0 py-4" style="font-size: 13px; text-align: center;">{{ item?.date }}</p>
                                        </div>
                                    </div>
                                    <div class="col-7 col-lg-8">
                                        <a *ngIf="item?.urlPath" [href]="item.urlPath" target="_blank" rel="noopener noreferrer" class="text-primary text-decoration-none fw-semibold">{{ item?.title }} <i class="fa-solid fa-arrow-up-right-from-square small ms-1"></i></a>
                                        <a *ngIf="!item?.urlPath" class="fw-semibold">{{ item?.title }}</a><br>
                                        <small *ngIf="item?.desc">{{ item.desc.length > 100 ? (item.desc | slice: 0:100) + '...' : item.desc }}</small>
                                    </div>
                                </div>
                            </li>
                        </marquee>
                    </ul>
                </div>
            </div>

            <!-- NEWS & EVENTS -->
            <div class="col-12 col-md-4 mb-3">
                <div class="card news shadow mx-auto ml-md-4 mb-2" data-scroll>
                    <div class="card-header home-title">
                        NEWS &amp; EVENTS
                    </div>
                    <ul class="list-group list-group-flush">
                        <marquee behavior="scroll" direction="up" onmouseover="this.stop();" onmouseout="this.start();">
                            <li class="list-group-item" *ngFor="let item of news;" (click)="openItem(item)" [style.cursor]="item?.urlPath ? 'pointer' : 'default'">
                                <div class="row">
                                    <div class="col-5 col-lg-4">
                                        <div class="box d-flex justify-content-center align-items-center rounded-3">
                                            <p class="mb-0 py-4" style="font-size: 13px; text-align: center;">{{ item?.date }}</p>
                                        </div>
                                    </div>
                                    <div class="col-7 col-lg-8">
                                        <a *ngIf="item?.urlPath" [href]="item.urlPath" target="_blank" rel="noopener noreferrer" class="text-primary text-decoration-none fw-semibold">{{ item?.title }} <i class="fa-solid fa-arrow-up-right-from-square small ms-1"></i></a>
                                        <a *ngIf="!item?.urlPath" class="fw-semibold">{{ item?.title }}</a><br>
                                        <small *ngIf="item?.desc">{{ item.desc.length > 100 ? (item.desc | slice: 0:100) + '...' : item.desc }}</small>
                                    </div>
                                </div>
                            </li>
                        </marquee>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</div>